<template>
  <p class="manual-text">
    <slot />
  </p>
</template>

<script>
export default {
  name: "ManualText"
};
</script>

<style lang="scss">
.manual-text {
  font-family: "Montserrat";
  /* font-size: 37px; */
  font-size: 26px;
  line-height: 1.21;
  text-align: center;
  width: 930px;
  max-width: 90%;
  margin: 0 auto;
  text-shadow: 0px 0px 30px #e83133;

  @include breakpoint("md-and-down") {
    font-size: 22px;
  }

  @include breakpoint("sm-and-down") {
    font-size: 18px;
  }

  @include breakpoint("xs-only") {
    font-size: 14px;
  }
}
</style>
